<template>
  <ion-tabs>

    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>

    <!-- tab nav bar -->
    <template slot="bottom">
      <ion-tab-bar ref="IndexTabBar">
        <router-link v-for="(item, m_index) in navigation"
                     :to="{ name: item.route }"
                     :key="m_index"
                     :class="[item.disabled? 'tab-disabled' : '', 'tab-router-link']"
                     :event="!item.disabled ? 'click' : ''">
          <svg class="tab-icon">
            <use :xlink:href="'#'+item.icon"></use>
          </svg>
          <ion-label class="tab-text">{{ item.title }}</ion-label>
        </router-link>
      </ion-tab-bar>
    </template>

  </ion-tabs>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
      name: 'Index',
      beforeRouteUpdate(to, from, next) {
          this.redirectToFirstTab(to.name);
          next();
      },
      computed: {
          ...mapState({
              navigation: state => state.config.navigation ? state.config.navigation.tabs : [],
          }),
      },
      mounted() {
          this.redirectToFirstTab(this.$route.name);
      },
      methods: {
          redirectToFirstTab(routeName) {
              if (routeName == 'Index') {
                  setTimeout(() => {
                      this.$router.push({name: 'Dashboard'})
                  }, 10)
              }
          },
      }
  }
</script>